import { PREDECISION_GATEWAY_EVENT_PROMISES } from "../events";
/**
 * See `PreDecisionGatewayEventPromises` for documentation.
 */ const preDecisionGatewayEventPromises = async (param)=>{
    let { supportsCookiesName } = param;
    const promises = [];
    document.dispatchEvent(new CustomEvent(PREDECISION_GATEWAY_EVENT_PROMISES, {
        detail: {
            promises
        }
    }));
    try {
        const results = await Promise.all(promises);
        for (const result of results){
            if (result) {
                return result;
            }
        }
    } catch (e) {
    // Silence is golden.
    }
    return false;
};
export { preDecisionGatewayEventPromises };
